import cn from 'classnames'

import cls from  './Disclamer.module.scss'

export const Disclamer = () => (
    <div className={cn([cls.disclamer, 'bold'])}>
        Сервис OnlyCash полностью бесплатный. Мы не запрашиваем такие данные как номера карт. Будьте бдительны!
    </div>
)